import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmSubscription } from '../../services/subscriptionService';
import { userService } from '../../services/userService';
import { useAuth } from '../../AuthContext';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SubscriptionConfirm() {
  const query = useQuery();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Verifying payment…');
  const { setUserRole } = useAuth();

  useEffect(() => {
    async function run() {
      const reference = query.get('reference') || query.get('trxref');
      const plan = query.get('plan');

      const token = localStorage.getItem('token');
      if (!token) {
        setStatus('Authentication required. Redirecting to login…');
        setTimeout(() => navigate('/auth'), 2000);
        return;
      }

      if (!reference) {
        setStatus('Missing payment reference.');
        return;
      }
      try {
        const res = await confirmSubscription(reference, plan || undefined);

        // 1. Persist fresh token FIRST (role is embedded inside), so any
        //    route guard reading role from the JWT will see the new role.
        if (res.token) {
          localStorage.setItem('token', res.token);
        }

        // 2. Update user object and backend role as a fallback
        let user = res?.user || null;
        if (!user) {
          try {
            user = await userService.updateMyRole('ecommerce');
          } catch (err) {
            console.error('Role update failed:', err);
          }
        }

        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
        }

        // 3. Persist role explicitly, then push it into AuthContext state.
        //    setUserRole() also writes localStorage.role.
        if (setUserRole) {
          setUserRole('ecommerce');
        } else {
          localStorage.setItem('role', 'ecommerce');
        }

        setStatus('Subscription activated! Redirecting to your dashboard…');

        // 4. Conditional Redirect: Skip profile if already completed
        const hasProfile = user?.businessName && user?.businessType && user?.location;

        setTimeout(() => {
          if (hasProfile) {
            navigate('/dashboard/ecommerce', { replace: true });
          } else {
            navigate('/dashboard/ecommerce/profile', { replace: true });
          }
        }, 2000);
      } catch (e) {
        setStatus(`Verification failed: ${e.message || 'Unknown error'}`);
        console.error('Subscription confirmation error:', e);
      }
    }
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-6 text-center">
      <div className="text-lg">{status}</div>
    </div>
  );
}
